import React from 'react';

import {Table,Button} from 'react-bootstrap';
import Icon from '../../../../../../components/Icon';

import './index.css';

const PayoutsTable = (props) => {
    const {payouts} = props;

    const rows = Object.keys(payouts).map(cc => {
        if(cc == 'default') return;
        const value = payouts[cc];
        return (
            <tr key={cc}>
                <td>{cc}</td>
                <td>
                    <input
                        type="text"
                        value={value}
                        name={cc}
                        onChange={props.onChange}
                        className="payout-input"
                    />
                </td>
                <td>
                    <Button bsStyle="danger" onClick={() => props.onRemove(cc)} ><Icon name="times"/> Remove</Button>
                </td>
            </tr>
        );
    });

    return (
        <Table bordered responsive>
            <thead>
                <tr>
                    <th>Country</th>
                    <th>Payout</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    );
}

export default PayoutsTable;


// WEBPACK FOOTER //
// ./src/scenes/Payouts/components/Form/components/PayoutsTable/index.js